export default {
  tabs: {
    gift_cards: 'Karty podarunkowe',
    settings: 'Ustawienia',
  },
  gift_cards: {
    title: 'Karty podarunkowe',
    subtitle: 'Zarządzaj wszystkimi kartami podarunkowymi swojej restauracji',
    buttons: {
      create: 'Utwórz kartę podarunkową',
      redeem: 'Zrealizuj kartę podarunkową',
      check_balance: 'Sprawdź saldo',
    },
    search: {
      placeholder: 'Wpisz tekst wyszukiwania',
    },
    columns: {
      code: 'Kod',
      status: 'Status',
      balance: 'Saldo',
      value: 'Wartość',
      email: 'Nabywca',
      source: 'Źródło',
      created_at: 'Utworzono',
    },
    statuses: {
      active: 'Aktywna',
      partially_redeemed: 'Częściowo zrealizowana',
      redeemed: 'Zrealizowana',
    },
  },
  settings: {
    gift_cards_availability: {
      title: 'Ustawienia kart podarunkowych',
      subtitle: 'Skonfiguruj opcje kart podarunkowych dla swojej restauracji',
      availability: {
        title: 'Włącz karty podarunkowe',
        subtitle: 'Pozwól klientom kupować i realizować karty podarunkowe',
        buttons: {
          enable: 'Włącz',
          disable: 'Wyłącz',
        },
      },
    },
    redemption_options: {
      title: 'Opcje realizacji',
      subtitle: 'Wybierz, gdzie klienci mogą realizować karty podarunkowe',
      redemption_mode: {
        title: 'Tryb realizacji',
        subtitle: 'Wpływa na treść wyświetlaną na stronie kart podarunkowych',
        buttons: {
          online: 'Tylko online',
          online_and_store: 'Online i stacjonarnie',
        },
      },
    },
  },
  summary: {
    total_value: 'Łączna wartość',
    total_active: 'Łącznie aktywnych',
    redeemed_this_month: 'Zrealizowane w tym miesiącu',
  },
};
